import type { SeparatorParams, SeparatorReturn } from '../types';

export default function (data: SeparatorParams): SeparatorReturn {
  return {
    module: 'SSeparator',
    type: data.type || 'separator',
    size: data.size || 'medium'
  };
}
